(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('collaboration', {
            parent: 'entity',
            url: '/collaboration?page&sort&search',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.collaboration.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/collaboration/collaborations.html',
                    controller: 'CollaborationController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collaboration');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('collaboration-detail', {
            parent: 'entity',
            url: '/collaboration/{id}',
            data: {
                authorities: ['ROLE_SYSTEM'],
                pageTitle: 'sigmasfApp.collaboration.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/collaboration/collaboration-detail.html',
                    controller: 'CollaborationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('collaboration');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Collaboration', function($stateParams, Collaboration) {
                    return Collaboration.get({id : $stateParams.id});
                }]
            }
        })
        .state('collaboration.new', {
            parent: 'collaboration',
            url: '/new',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collaboration/collaboration-dialog.html',
                    controller: 'CollaborationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                nameEn: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('collaboration', null, { reload: true });
                }, function() {
                    $state.go('collaboration');
                });
            }]
        })
        .state('collaboration.edit', {
            parent: 'collaboration',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collaboration/collaboration-dialog.html',
                    controller: 'CollaborationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Collaboration', function(Collaboration) {
                            return Collaboration.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collaboration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('collaboration.delete', {
            parent: 'collaboration',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SYSTEM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/collaboration/collaboration-delete-dialog.html',
                    controller: 'CollaborationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Collaboration', function(Collaboration) {
                            return Collaboration.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('collaboration', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
